module.exports = __webpack_public_path__ + "static/media/close-cross.51c350f5.svg";